import $ from 'jquery';
import Glide from '@glidejs/glide';

export const PXPatientStoriesSlider = (function () {
	'use strict';

	let sliders;

	function init() {
		sliders = document.querySelectorAll('.pxblock--patient-stories-slider .glide');

		if (sliders.length === 0) return;

		sliders.forEach((s) => {
			let sliderNavButtons = s.querySelectorAll('.glide__arrows > button');
			let g = new Glide(s, {
				type: 'slider',
				perView: 3,
				gap: 0,
				breakpoints: {
					800: {
						perView: 1,
					},
				},
			}).mount();

			sliderNavButtons.forEach((b) => {
				b.addEventListener('click', function (ev) {
					let dir = this.classList.contains('prev') ? '<' : '>';
					g.go(dir);
				});
			});
		});
	}

	return {
		init: init,
	};
})();
